<script>
import BaseButton from '@/js/components/common/buttons/BaseButton';

export default {
    name: 'BackButton',

    functional: true,

    props: {
        label: {type: String, default: null},
        hideLabel: {type: Boolean},
        isSmall: {type: Boolean},
        disabled: {type: Boolean},
        referrer: {type: String, default: null},
    },

    render(createElement, {props, data, parent}) {
        data.props = {
            label: props.label || parent.$t('common.actions.back'),
            iconClass: 'fa fa-chevron-left',
            color: 'btn-outline-secondary',
            isSmall: props.isSmall,
            hideLabel: props.hideLabel,
            disabled: props.disabled,
        };

        data.on = {
            click: (event) => {
                event.preventDefault();
                parent.$appHistory.goBack(props.referrer);
            },
        };

        return createElement(BaseButton, data);
    },
};
</script>
